import { useEffect } from "react";

const CalculadoraRedirect = () => {
  useEffect(() => {
    window.location.replace("/calculadora.html");
  }, []);
  return (
    <div data-testid="calculadora-redirect" style={{ minHeight: "100vh", background: "#0A1E3F" }} />
  );
};

export default CalculadoraRedirect;
